"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-CSVImport',
    title: 'c-CSVImport__title',
    message: 'c-CSVImport__message',
    option: {
        container: 'c-CSVImport__option',
        textContainer: 'c-CSVImportOption__text-container',
        text: 'c-CSVImportOption__text',
        value: 'c-CSVImportOption__value',
        importing: 'c-CSVImport__importing',
        download: 'c-CSVImportOption__download',
        downloadDisabled: 'c-CSVImportOption__download--disabled',
    },
    importButton: 'c-CSVImport__button',
    isOptionComplete: 'c-CSVImportOption--is-complete',
    isOptionIconComplete: 'c-CSVImportIcon--is-complete',
    isTooManyCollections: 'c-CSVImport--too-many-collections',
    job: {
        container: 'c-CSVImport__job',
    },
    form: {
        container: 'c-CSVImport__form',
    },
    file: {
        container: 'c-CSVImport__file',
        drop: 'c-CSVImport__drop',
    },
    csv: {
        container: 'c-CSVImport__csv',
    },
    tabBar: {
        container: 'c-Tab-bar',
        tab: 'c-TabBar__tab',
        tabActive: 'c-TabBar__tab--active',
    },
    importNotifications: {
        container: 'c-ImportNotifications',
        collectionLink: 'c-ImportNotifications__collectionLink',
    },
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        width: '80%',
        margin: theme_1.DefaultTheme.space(4),
        'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
    },
    [exports.CSS.title]: {
        padding: '0 ' + theme_1.DefaultTheme.space(6),
        height: theme_1.DefaultTheme.space(12),
        'line-height': theme_1.DefaultTheme.space(12),
        display: 'flex',
        '& h6': {
            margin: 0,
            'line-height': theme_1.DefaultTheme.space(12),
        },
    },
    [exports.CSS.message]: {
        padding: theme_1.DefaultTheme.space(6),
    },
    [exports.CSS.option.container]: {
        padding: theme_1.DefaultTheme.space(4),
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'space-between',
    },
    [exports.CSS.option.importing + ' .c-Spinner']: {
        'margin-right': theme_1.DefaultTheme.space(4),
    },
    [exports.CSS.option.value]: {
        display: 'flex',
        'align-items': 'center',
        height: theme_1.DefaultTheme.space(10),
        width: '300px',
    },
    [exports.CSS.option.textContainer]: {
        'font-size': '120%',
        display: 'flex',
        flex: '1',
        'align-items': 'center',
        padding: theme_1.DefaultTheme.space(1),
        '& i': {
            'padding-right': '16px',
        },
    },
    [exports.CSS.option.text]: {
        paddingRight: theme_1.DefaultTheme.space(2),
        '&:only-child': {
            paddingLeft: `calc(${theme_1.DefaultTheme.space(4)} + 24px)`,
        },
    },
    [exports.CSS.option.download]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        'font-size': '120%',
        padding: `${theme_1.DefaultTheme.space(2)} ${theme_1.DefaultTheme.space(4)}`,
        boxSizing: 'border-box',
        border: '1px solid black',
        color: 'black',
        cursor: 'pointer',
        '&:hover': {
            background: theme_1.DefaultTheme.background.lightGrey,
            borderColor: theme_1.DefaultTheme.color.accent,
            color: theme_1.DefaultTheme.color.accent,
        },
        '&:active': {
            background: theme_1.DefaultTheme.background.active,
        },
        '& i': {
            'padding-right': '4px',
        },
    },
    [exports.CSS.option.downloadDisabled]: {
        pointerEvents: 'none',
        opacity: 0.5,
    },
    [exports.CSS.isOptionComplete]: {
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [exports.CSS.isOptionIconComplete]: {
        color: 'green',
    },
    [exports.CSS.isTooManyCollections]: {
        padding: theme_1.DefaultTheme.space(4),
        'font-weight': 'bold',
    },
    [exports.CSS.csv.container]: {
        padding: theme_1.DefaultTheme.space(4),
        'align-items': 'center',
        'justify-content': 'space-between',
    },
    [exports.CSS.file.drop]: {
        height: '56px',
        width: '300px',
    },
    [exports.CSS.importButton]: {
        padding: theme_1.DefaultTheme.space(4),
        'text-align': 'right',
    },
    [exports.CSS.tabBar.container]: {
        padding: theme_1.DefaultTheme.space(4),
        display: 'flex',
    },
    [exports.CSS.tabBar.tab]: {
        position: 'relative',
        padding: `${theme_1.DefaultTheme.space(4)} ${theme_1.DefaultTheme.space(6)}`,
        'font-size': '120%',
        cursor: 'pointer',
        transition: '0.1s',
        overflow: 'hidden',
        userSelect: 'none',
        '&:after': {
            content: '""',
            position: 'absolute',
            bottom: '0',
            left: '0',
            display: 'block',
            width: '100%',
            height: '0px',
            background: theme_1.DefaultTheme.color.accent,
            transition: '0.1s',
        },
        '&:hover': {
            background: theme_1.DefaultTheme.background.lightGrey,
        },
        '&:active': {
            background: theme_1.DefaultTheme.background.active,
        },
        [`&:not(.${exports.CSS.tabBar.tabActive}):hover:after`]: {
            height: '2px',
        },
    },
    [exports.CSS.tabBar.tabActive]: {
        '&:after': {
            height: '4px',
        },
    },
    [exports.CSS.importNotifications.container]: {
        display: 'flex',
        'flex-direction': 'column',
        gap: '15px',
        '& > div > div': {
            display: 'flex',
            'align-items': 'center',
        },
        '& > div > div > .material-icons': {
            'margin-right': '4px',
        },
        '& td': {
            border: '1px solid #ccc',
            padding: '4px',
        },
        '& th': {
            border: '1px solid #ccc',
            padding: '4px',
        },
        '& tr': {
            border: '1px solid #ccc',
        },
        '& table': {
            border: '1px solid #ccc',
            'border-collapse': 'collapse',
        },
    },
    [exports.CSS.importNotifications.collectionLink]: {
        'margin-right': '4px',
    },
});
//# sourceMappingURL=import.style.js.map